import './person-avatar.scss';

import React from 'react';

import { getNameInitials } from './utils';

type PersonAvatarProps = {
  name: string;
  src?: string;
  size?: 'sm' | 'lg';
  className?: string;
};

export const PersonAvatar: React.FC<PersonAvatarProps> = ({
  name,
  src,
  size = 'sm',
  className = '',
}) => {
  const sizeClass = size === 'lg' ? 'person-avatar--lg' : 'person-avatar--sm';

  if (src) {
    return (
      <img
        src={src}
        className={`person-avatar ${sizeClass} rounded-circle ${className}`.trim()}
        alt={name}
        loading="lazy"
        decoding="async"
      />
    );
  }

  return (
    <div
      className={`person-avatar person-avatar-placeholder ${sizeClass} rounded-circle ${className}`.trim()}
      aria-label={name}
    >
      <span className="person-avatar-initials">{getNameInitials(name)}</span>
    </div>
  );
};
